export const ResetStateActionType = 'users/clearStore';
